<script setup lang="ts">
defineProps<{
  className?: string;
}>();
</script>

<template>
  <button
    :class="[
      'font-medium text-[14px] font-roboto text-center text-brown px-[20px] py-[6px] border border-primaryDense transition-none duration-1000 ease-in hover:text-white hover:bg-gradient-to-r hover:from-primary hover:to-primaryDense',
      className,
    ]"
  >
    <slot />
  </button>
</template>
